import React from 'react';

class RegisterNotYet extends React.Component {
  render() {
    return (
      <React.Fragment>
        <p>Registration opens on <strong>22 Jul 2019</strong> and closes on <strong>30 Sep 2019</strong>.</p>
        <a href="https://bestcoderchallenge2019.formstack.com/forms/bestcoder2019" className="btn btn-primary" target="_blank" rel="noopener noreferrer">Register Now</a>
      </React.Fragment>
    )
  }
}

class RegisterOnGoing extends React.Component {
  render() {
    return (
      <React.Fragment>
        <p>Ready to put your coding skills to the test? Register now!</p>
        <a href="https://bestcoderchallenge2019.formstack.com/forms/bestcoder2019" className="btn btn-primary" target="_blank" rel="noopener noreferrer">Register Now</a>
      </React.Fragment>
    )
  }
}

class RegisterClose extends React.Component {
  render() {
    return (
      <React.Fragment>
        <p>Registration for I’m the Best Coder! Challenge 2019 is closed.</p>
      </React.Fragment>
    )
  }
}

class Register extends React.Component {
  constructor() {
    super();
    this.entry = undefined;
  }

  render() {
    // 22 Jul 2019 - Registration Opens
    // 10 Sep 2019 - Registration Closes  
    // Date: new Date().getTime() today 1562040427128
    const regStart = 1563753600000,
      regEnd = 1568131199,
      today = new Date().getTime();
    if (today < regStart) {
      this.entry = <RegisterNotYet />;
    } else if (today > regStart & today < regEnd) {
      this.entry = <RegisterOnGoing />;
    } else if (today > regEnd) {
      this.entry = <RegisterClose />;
    } else {
      this.entry = <RegisterNotYet />;
    }
    return (
      <section id="register" className="white">
        <div className="container">
          <div className="box" style={{padding: "100px 0 90px"}}>
          <div className="section-title">
            <h2>Register</h2>
          </div>
          {this.entry}
          </div>
        </div>
      </section>
    )
  }
};

export default Register;